// Breadcrumb

export default class Breadcrumb {
    constructor() {
        this.ui = this.getUI();
        this.listen();
    }

    getUI() {
        return {
            breadcrumbBtn: document.querySelectorAll(".breadcrumb__btn-link"),
            breadcrumbList: document.querySelectorAll(".breadcrumb__list")
        }
    }

    listen() {
       if(this.ui.breadcrumbBtn.length > 0) {
            this.ui.breadcrumbBtn[0].addEventListener("click", () => {
                this.ui.breadcrumbBtn[0].style.display = "none";
                this.ui.breadcrumbList[0].style.display = "block";
                this.ui.breadcrumbList[0].querySelector('.breadcrumb__list-link').focus();
            });
        }
    }
}